// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WrapTextOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WrapTextOffIcon" ref={forwardedRef} {...props}>
      <path d="M13.495 10.498h2.009V14H11v1.498h5a1 1 0 0 0 1-1v-4.5a1 1 0 0 0-1-1h-1.005z" />
      <path d="M10.752 8.998H3v1.5h6.252z" />
      <path d="M14.252 5.498H3.004v-1.5h12.748z" />
      <path d="M5.75 14H3v1.498h1.252z" />
      <path d="m12.172 17.553-2.828-2.828 2.828-2.829 1.062 1.062-1.77 1.77 1.767 1.766z" />
      <path d="M3.002 16.75 15.73 4.022l1.06 1.061L4.063 17.811z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const WrapTextOffIcon = /* @__PURE__ */ Object.assign(
  WrapTextOffIconComponent,
  { displayName: 'WrapTextOffIcon' },
);
